// extracted by mini-css-extract-plugin
export var barContainer = "_5x-0";
export var extraThin = "_5x-3";
export var fillBar = "_5x-6";
export var fillContainer = "_5x-4";
export var overflow = "_5x-8";
export var overflowContainer = "_5x-5";
export var regular = "_5x-7";
export var thick = "_5x-1";
export var thin = "_5x-2";